const apiBaseUrl = process.env.REACT_APP_API_URL || 'http://localhost:8080';

export default async function apiFetch(path, options = {}) {
  const response = await fetch(`${apiBaseUrl}${path}`, {
    credentials: 'include',
    ...options,
  });

  if (response.status === 401 && typeof window !== 'undefined') {
    if (window.location.pathname !== '/login') {
      window.location.assign('/login');
    }
  }

  return response;
}
